const transform = ({ data }) => {
  const { documents } = data;

  return documents || [];
};

export { transform };
